var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRedo = function SvgRedo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 6.25c.312 0 .562-.25.562-.562V2.313a.56.56 0 0 0-.562-.563.56.56 0 0 0-.563.563V4.19l-.468-.55a5.25 5.25 0 1 0-.881 7.56.564.564 0 0 0-.675-.9 4.125 4.125 0 1 1 .694-5.939l.001.005.647.76H8.5a.56.56 0 0 0-.563.562c0 .312.251.562.563.562z"
  })));
};
export default SvgRedo;